import { Injectable } from '@angular/core';
import { AppConfig } from '../models/app-config.model';


@Injectable()
export class AppConfigStore {
    appConfig: AppConfig;

    constructor() {
        this.appConfig = {
            companyName: 'eatgood',
            contactEmail: 'contact@eatgood.co.il',
            webUrl: 'eatgood.co.il',
            type: 'daysPlanner',
            unitsType: 'kg',
            plans: ['standard', 'vegan', 'vegetarian', 'pescetarian'],
        };
    }

}
